<div class="row justify-content-center">
  <div class="col-md-11 col-lg-9">
    <form class="form-container center-screen p-1 my-2" [formGroup]="regionAdminForm">
      <lms-table-wrapper class="center-screen mt-1 mb-3" [config]="config">
        <table class="table table-striped table-auto table-sm shadow-1-strong rounded-1 p-1" style="width:750px;">
          <thead class="table-center-header">
            <tr>
              <td style="width: 50px;">Id</td>
              <td>Region</td>
              <td style="width: 40%;">Areas</td>
              <td>Edit</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ar of (dbregions ?? []) | paginate: config; let i = index;">
              <td>{{ar.id}}</td>
              <td class="text-center font-black fw-bold">{{ar.name}}</td>
              <td>
                <div class="list-group z-depth-1 my-1 py-1">
                  <div class="list-group-item" *ngFor="let item1 of ar.areas;">{{ item1.name }}
                  </div>
                </div>
              </td>
              <td>
                <button class="btn btn-floating btn-icon fs-5 fas" mdbRipple (click)="selectRegion(ar)">
                  <i class="fas fa-xs fa-fw fa-pencil"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </lms-table-wrapper>

      <div class="center-screen">
        <button class="btn btn-primary btn-sm" type="button" (click)="createNewRegion()">Create a new region</button>
      </div>

    </form>
  </div>
</div>
